// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"TD-z","cltLink":"UD-z","shippingDisclaimer":"VD-z"};